import { connect } from 'react-redux'
import { setSearchResultsLoaded } from 'redux/actions'
import PagedSearchResults from 'pages/search/PagedSearchResults'

const mapStateToProps = (state) => ({
  isMobile: state.layout.deviceType.isMobile,
  pageId: state.layout.pageId,
  aol: state.aol.name,
  vectorResults:
    state.search.response && state.search.response.vectorResults
      ? state.search.response.vectorResults
      : []
})

const mapDispatchToProps = (dispatch) => ({
  setSearchResultsLoaded: (isLoaded) =>
    dispatch(setSearchResultsLoaded(isLoaded))
})

export default connect(mapStateToProps, mapDispatchToProps)(PagedSearchResults)
